import React from "react";

const VideoComponent = () => {
  return (
    <div id="videoContainer" className="video-container">
      <iframe
        src="https://www.youtube.com/embed/ah7dPQEUrAo?si=oSSrB48jZ9Dv3j9t"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>

      <style jsx>{`
        .video-container {
          margin: auto;
          height: 100dvh;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .video-container iframe {
          margin: auto;
          height: 80dvh;
          width: 80dvw;
        }
      `}</style>
    </div>
  );
};

export default VideoComponent;
